import { BH_BASE_URL } from "@helper/getEnvVariables";
import { removeTrailingSlash } from "@helper/removeTrailingLeadingSlash";
import { getCurrentDate } from "@helper/useDateFormat";

export const generateUTMUrl = (urlPath: string | undefined, title: string) =>
  `${removeTrailingSlash(BH_BASE_URL)}${urlPath}?utm_source=emarsys&utm_medium=email&utm_campaign=bh_newsletter&utm_term=${encodeURIComponent(title).replace(/%20/g, "+")}&utm_content=${getCurrentDate("dd/MM/yyyy")}`;
